import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import JobList from "./components/JobList";
import 'semantic-ui-css/semantic.min.css';
import './assets/css/index.css';


ReactDOM.render(
    <main>
        <JobList />
    </main>,
    document.getElementById('root')
);

